import React, {useCallback, useState} from 'react';
import {LoginBranding} from '@components/login/LoginBranding';
import Button from '@material-ui/core/Button';
import './ExternalCallLogin.sass';
import 'styles/Login.styl';
import LoginTextField from '@components/text-field/LoginTextField';
import LoginInputLabel from '@components/input-label/LoginInputLabel';
import {createStyles, withStyles} from '@material-ui/core/styles';
import {SpinnerCircular} from 'spinners-react';

interface ExternalCallLoginProps {
  onLogin: (password: string) => Promise<void>;
  incorrectPassword: boolean;
}

export const ExternalCallLogin: React.FC<ExternalCallLoginProps> = ({
  incorrectPassword,
  onLogin,
}) => {
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(
    e => {
      e.preventDefault();
      if (password) {
        setSubmitting(true);
        onLogin(password).finally(() => setSubmitting(false));
      }
    },
    [password, onLogin, setSubmitting]
  );

  return (
    <div className="login-page">
      <LoginBranding />
      <div className="sidebar">
        <form className="external-login" onSubmit={submit}>
          <LoginInputLabel htmlFor="login-password">Password</LoginInputLabel>
          <LoginTextField
            fullWidth
            id="login-password"
            name="password"
            type="password"
            onChange={event => setPassword(event.target.value)}
            error={incorrectPassword}
          />
          {incorrectPassword && (
            <div className="error-message">The password you entered was incorrect.</div>
          )}
          <LoginButton
            type="submit"
            onClick={submit}
            disabled={!password}
            color="primary"
            size="large"
            variant="contained">
            {submitting && <SpinnerCircular size={15} className="spinner" />}
            Login
          </LoginButton>
        </form>
      </div>
    </div>
  );
};

const LoginButton = withStyles(() =>
  createStyles({
    root: {
      height: 42,
      alignSelf: 'flex-end',
    },
  })
)(Button);
